import React from "react";
import CustomCard from "../../shared/Card/CustomCard";
import ServiceForm from "./ServiceForm";

export default function ViewService({ name }) {
    return (
        <CustomCard title={name}>
            <ServiceForm type="VIEW" />
        </CustomCard>
    );
}
